import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import {
    loadAttachmentAsFile,
    openAttachmentAsDraft,
    openAttachmentFufAsDraft,
} from "../../../Engine/ActionCreators/AttachmentActionCreators";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { FileProps } from "../../../Engine/Core/ModalManager/Modals/Utils/Types";
import { CustomFile } from "../../../Helpers/file";
import { UploadedFileInfo, uploadFufFileAction } from "../../../Engine/ActionCreators/FufUploadActionCreator";
import { AttachInfo } from "../../../../../Common/CandyApiClient/Types/Attachments/Attacments";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { withViewModelSelect } from "../../withViewModelSelect";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { AttachmentInfoPath } from "../../../../../Common/PathConstants";
import { UploadFileOptions, UploadFormTypes } from "../../../Engine/Externals/FufManager/IFufManager";
import { getPortalUserInfo } from "../../../Engine/ActionCreators/AllActionCreators";

import { AttachmentForm } from "./AttachmentForm";

interface AttachmentFormContainerProps {
    requestedGfv: string;
    caption: string;
    description: string;
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
    isFormInFormNds: boolean;
}

const mapStateToProps = (state: FullFormState, ownProps: AttachmentFormContainerProps) => {
    const attachmentId = ownProps.bindingPath.resolved
        ? ownProps.viewModelSelect.controlModel(state, ownProps.bindingPath.joinWith(AttachmentInfoPath))?.value
        : null;

    return {
        attachmentInfo: attachmentId ? state.attachments.byId[attachmentId] : undefined,
        caption: ownProps.caption,
        description: ownProps.description,
        currentGfv: state.settings.gfv,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: AttachmentFormContainerProps) => ({
    onOpenAsDraft: () => dispatch(openAttachmentAsDraft(ownProps.requestedGfv, ownProps.bindingPath)),
    onOpenFufAsDraft: (attachInfo: AttachInfo) => dispatch(openAttachmentFufAsDraft(attachInfo)),
    onLoadAttachmentFile: (loadedFileProps: FileProps) =>
        dispatch(loadAttachmentAsFile(loadedFileProps, ownProps.requestedGfv, ownProps.bindingPath)),
    getFileProperties: (file?: CustomFile, options?: UploadFileOptions): Promise<UploadedFileInfo> =>
        dispatch(
            uploadFufFileAction(
                file,
                true,
                true,
                options !== undefined
                    ? {
                          formType: ownProps.isFormInFormNds ? UploadFormTypes.NDS : UploadFormTypes.default,
                          requestedGfv: options.requestedGfv,
                          declarationGfv: options.declarationGfv,
                      }
                    : undefined
            )
        ),
    getPortalUserId: async (): Promise<string> => {
        const res = await dispatch(getPortalUserInfo());

        if (!res.Id) {
            throw new Error("Portal user id not found");
        }

        return res.Id;
    },
});

export const AttachmentFormContainer = withViewModelSelect(
    connect(mapStateToProps, mapDispatchToProps)(AttachmentForm)
);
